export class WorkflowSession {
    id: number;
    currentPageNo:number;
    data:any;
}

